export const finishedConfigurations = {
  title: 'Zakończone Szablony Konfiguracji',
  signature: 'Sygnatura',
  type: 'Rodzaj',
  mail: 'Mail',
  confirmedDate: 'Data zatwierdzenia',
  displayConfiguration: 'Podgląd szablonu konfiguracji',
  search: 'Wyszukaj',
  shared: 'Udostępniona',
  sectionInfo: {
    signature: 'Sygnatura',
    source: 'Źródło',
    updatedAt: 'Modyfikowana',
    email: 'Adres e-mail',
  },
  user: {
    notGivenToken: 'Błędny URL. Brak wymaganego tokenu.',
    invalidToken: 'Nie znaleziono danych dla podanego tokena',
    expiredToken: 'Podany token wygasł',
  },
}
